import { render, staticRenderFns } from "./fieldCustomSubmit.vue?vue&type=template&id=1da82616"
import script from "./fieldCustomSubmit.vue?vue&type=script&lang=js"
export * from "./fieldCustomSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports